import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

/**
 * Componente de diálogo de erro com opção de tentar novamente.
 * @component
 * @param {Object} props - Propriedades do componente.
 * @param {Error} props.error - O erro a ser exibido.
 * @param {Function} props.resetErrorBoundary - Função para redefinir o estado do erro.
 * @returns {JSX.Element} - O diálogo de erro.
 */
const ErrorTryAgain = ({ error, resetErrorBoundary }) => {
  const handleClose = () => {
    resetErrorBoundary();
  }
  return (
    <Dialog
      open={true}
    >
      <DialogTitle style={{ color: "red" }}>
        {"Ocorreu um Erro:"}
      </DialogTitle>
      <DialogContent>
        <pre>{error.message}</pre>
        <DialogActions>
          <Button onClick={handleClose} variant="contained" color="error">Tentar novamente</Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}
export default ErrorTryAgain;